import React from 'react';
import PropTypes from 'prop-types';

import {
  questionShape,
  answerShape,
  questionGroupShape,
  groupQuestionAnsweredShape
} from '../../../shapes/entities';
import { modeType } from '../../../shapes/types';
import RichContentViewer from '../../../../../shared/components/rich/viewer';
import HighlightContainer from '../../highlight/container';
import QuestionScreen from '../question';

const QuestionGroupScreen = ({
  source,
  questionsWithAnswers,
  mode,
  highlightsId,
  showHighlighter,
  alwaysShowSolution,
  showInstantSolution,
  autoExpandSolution,
  selected,
  onUpdateAnswer
}) => {
  const { columns, context } = source.attributes;

  const width = 12 / columns;
  return (
    <div key={source.id}>
      <HighlightContainer
        id={highlightsId}
        key={highlightsId}
        showControls={showHighlighter}
      >
        {context && <RichContentViewer content={context} />}

        <div className="l-grid t-margin-negative-large--bottom">
          {questionsWithAnswers.map(({ question, answers }, index) => (
            <div
              className={`l-grid__item l-width--${width}-of-12@medium t-margin-large--bottom`}
              key={index} // eslint-disable-line react/no-array-index-key
            >
              <QuestionScreen
                key={question.id}
                source={question}
                answers={answers}
                mode={mode}
                onUpdateAnswer={choices =>
                  onUpdateAnswer(selected.with(index, choices))
                }
                selected={selected[index]}
                showInstantSolution={showInstantSolution}
                alwaysShowSolution={alwaysShowSolution}
                autoExpandSolution={autoExpandSolution}
              />
            </div>
          ))}
        </div>
      </HighlightContainer>
    </div>
  );
};

QuestionGroupScreen.propTypes = {
  source: questionGroupShape.isRequired,
  mode: modeType.isRequired,
  selected: groupQuestionAnsweredShape.isRequired,
  highlightsId: PropTypes.string.isRequired,
  showHighlighter: PropTypes.bool,
  alwaysShowSolution: PropTypes.bool,
  showInstantSolution: PropTypes.bool,
  autoExpandSolution: PropTypes.bool,
  onUpdateAnswer: PropTypes.func.isRequired,
  questionsWithAnswers: PropTypes.arrayOf(
    PropTypes.shape({
      question: questionShape,
      answers: PropTypes.arrayOf(answerShape)
    })
  ).isRequired
};

QuestionGroupScreen.defaultProps = {
  alwaysShowSolution: false,
  showInstantSolution: false,
  autoExpandSolution: false,
  showHighlighter: false
};

export default QuestionGroupScreen;
